<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits([
  'add',
  'import',
  'export',
  'exports',
  'imports',
  'migration',
  'bulkLabelByPhone',
]);

const { t } = useI18n();

const contactMenuItems = computed(() => [
  {
    label: 'Minhas exportações',
    action: 'exports',
    value: 'exports',
    icon: 'i-hugeicons-download-04',
  },
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.ADD_CONTACT'),
    action: 'add',
    value: 'add',
    icon: 'i-lucide-plus',
  },
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT'),
    action: 'export',
    value: 'export',
    icon: 'i-lucide-upload',
  },
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT'),
    action: 'import',
    value: 'import',
    icon: 'i-lucide-download',
  },
  {
    label: 'Acompanhar importações',
    action: 'imports',
    value: 'imports',
    icon: 'i-lucide-list-checks',
  },
  {
    label: t('CONTACTS_BULK_ACTIONS.PHONE_IMPORT.MENU_LABEL'),
    action: 'bulkLabelByPhone',
    value: 'bulkLabelByPhone',
    icon: 'i-lucide-tags',
  },
  {
    label: 'Migrar conversas',
    action: 'migration',
    value: 'migration',
    icon: 'i-lucide-file-stack',
  },
]);
const showActionsDropdown = ref(false);

const handleContactAction = ({ action }) => {
  if (action === 'add') {
    emit('add');
  } else if (action === 'import') {
    emit('import');
  } else if (action === 'export') {
    emit('export');
  } else if (action === 'exports') {
    emit('exports');
  } else if (action === 'imports') {
    emit('imports');
  } else if (action === 'migration') {
    emit('migration');
  } else if (action === 'bulkLabelByPhone') {
    emit('bulkLabelByPhone');
  }
};
</script>

<template>
  <div v-on-clickaway="() => (showActionsDropdown = false)" class="relative">
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="contactMenuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleContactAction($event)"
    />
  </div>
</template>
